// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteApiFolderPermissionsByGraphFolderIdRemoveData, DeleteApiFolderPermissionsByGraphFolderIdRemoveErrors, DeleteApiFolderPermissionsByGraphFolderIdRemoveResponses, GetApiDirectoryUsersData, GetApiDirectoryUsersErrors, GetApiDirectoryUsersResponses, GetApiFolderPermissionsByGraphFolderIdData, GetApiFolderPermissionsByGraphFolderIdErrors, GetApiFolderPermissionsByGraphFolderIdResponses, GetApiLicensingCheckData, GetApiLicensingCheckErrors, GetApiLicensingCheckResponses, GetApiLicensingCurrentData, GetApiLicensingCurrentErrors, GetApiLicensingCurrentResponses, GetApiLicensingVersionData, GetApiLicensingVersionErrors, GetApiLicensingVersionResponses, GetApiMailFoldersData, GetApiMailFoldersErrors, GetApiMailFoldersResponses, PostApiFolderPermissionsApplyAllData, PostApiFolderPermissionsApplyAllErrors, PostApiFolderPermissionsApplyAllResponses, PostApiFolderPermissionsApplySelectedData, PostApiFolderPermissionsApplySelectedErrors, PostApiFolderPermissionsApplySelectedResponses, PostApiFolderPermissionsByGraphFolderIdAddData, PostApiFolderPermissionsByGraphFolderIdAddErrors, PostApiFolderPermissionsByGraphFolderIdAddResponses, PutApiFolderPermissionsByGraphFolderIdUpdateData, PutApiFolderPermissionsByGraphFolderIdUpdateErrors, PutApiFolderPermissionsByGraphFolderIdUpdateResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const getApiDirectoryUsers = <ThrowOnError extends boolean = false>(options?: Options<GetApiDirectoryUsersData, ThrowOnError>) => (options?.client ?? client).get<GetApiDirectoryUsersResponses, GetApiDirectoryUsersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/directory-users',
    ...options
});

export const getApiFolderPermissionsByGraphFolderId = <ThrowOnError extends boolean = false>(options: Options<GetApiFolderPermissionsByGraphFolderIdData, ThrowOnError>) => (options.client ?? client).get<GetApiFolderPermissionsByGraphFolderIdResponses, GetApiFolderPermissionsByGraphFolderIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/folder-permissions/{graphFolderId}',
    ...options
});

export const postApiFolderPermissionsApplyAll = <ThrowOnError extends boolean = false>(options?: Options<PostApiFolderPermissionsApplyAllData, ThrowOnError>) => (options?.client ?? client).post<PostApiFolderPermissionsApplyAllResponses, PostApiFolderPermissionsApplyAllErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/folder-permissions/apply-all',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiFolderPermissionsApplySelected = <ThrowOnError extends boolean = false>(options?: Options<PostApiFolderPermissionsApplySelectedData, ThrowOnError>) => (options?.client ?? client).post<PostApiFolderPermissionsApplySelectedResponses, PostApiFolderPermissionsApplySelectedErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/folder-permissions/apply-selected',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const postApiFolderPermissionsByGraphFolderIdAdd = <ThrowOnError extends boolean = false>(options: Options<PostApiFolderPermissionsByGraphFolderIdAddData, ThrowOnError>) => (options.client ?? client).post<PostApiFolderPermissionsByGraphFolderIdAddResponses, PostApiFolderPermissionsByGraphFolderIdAddErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/folder-permissions/{graphFolderId}/add',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiFolderPermissionsByGraphFolderIdRemove = <ThrowOnError extends boolean = false>(options: Options<DeleteApiFolderPermissionsByGraphFolderIdRemoveData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiFolderPermissionsByGraphFolderIdRemoveResponses, DeleteApiFolderPermissionsByGraphFolderIdRemoveErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/folder-permissions/{graphFolderId}/remove',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiFolderPermissionsByGraphFolderIdUpdate = <ThrowOnError extends boolean = false>(options: Options<PutApiFolderPermissionsByGraphFolderIdUpdateData, ThrowOnError>) => (options.client ?? client).put<PutApiFolderPermissionsByGraphFolderIdUpdateResponses, PutApiFolderPermissionsByGraphFolderIdUpdateErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/folder-permissions/{graphFolderId}/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiLicensingCheck = <ThrowOnError extends boolean = false>(options?: Options<GetApiLicensingCheckData, ThrowOnError>) => (options?.client ?? client).get<GetApiLicensingCheckResponses, GetApiLicensingCheckErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/licensing/check',
    ...options
});

export const getApiLicensingCurrent = <ThrowOnError extends boolean = false>(options?: Options<GetApiLicensingCurrentData, ThrowOnError>) => (options?.client ?? client).get<GetApiLicensingCurrentResponses, GetApiLicensingCurrentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/licensing/current',
    ...options
});

export const getApiLicensingVersion = <ThrowOnError extends boolean = false>(options?: Options<GetApiLicensingVersionData, ThrowOnError>) => (options?.client ?? client).get<GetApiLicensingVersionResponses, GetApiLicensingVersionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/licensing/version',
    ...options
});

export const getApiMailFolders = <ThrowOnError extends boolean = false>(options?: Options<GetApiMailFoldersData, ThrowOnError>) => (options?.client ?? client).get<GetApiMailFoldersResponses, GetApiMailFoldersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/mail-folders',
    ...options
});
